import type { DiagramToothAndBridgeListViewItem } from './diagram-tooth-and-bridge-list-view-item.model';

export const treatmentListItemSortKey = (item: DiagramToothAndBridgeListViewItem): { lastTouchedAt: number; tieBreakToothId: number } => {
	return { lastTouchedAt: item.lastTouchedAt, tieBreakToothId: item.startToothId };
};

export const compareTreatmentListItems = (a: DiagramToothAndBridgeListViewItem, b: DiagramToothAndBridgeListViewItem): number => {
	const ka = treatmentListItemSortKey(a);
	const kb = treatmentListItemSortKey(b);
	const primary = kb.lastTouchedAt - ka.lastTouchedAt;

	if (primary !== 0) {
		return primary;
	}

	const tie = ka.tieBreakToothId - kb.tieBreakToothId;

	if (tie !== 0) {
		return tie;
	}

	const aIsBridge = a.bridgeIndex !== undefined;
	const bIsBridge = b.bridgeIndex !== undefined;

	/** Same recency + same anchor id can occur for a bridge tooth row vs bridge summary row (left tooth). */
	if (aIsBridge !== bIsBridge) {
		return aIsBridge ? 1 : -1;
	}

	if (aIsBridge && bIsBridge) {
		return (a.bridgeIndex ?? 0) - (b.bridgeIndex ?? 0);
	}

	return 0;
};

export const treatmentListId = (item: DiagramToothAndBridgeListViewItem): number => {
	return item.startToothId;
};

export const treatmentListOptionKey = (item: DiagramToothAndBridgeListViewItem): string => {
	return item.bridgeIndex !== undefined ? `bridge:${item.bridgeIndex}` : `tooth:${item.startToothId}`;
};
